import classnames from 'classnames'
import * as React from 'react'
const styles = require('./styles')

export const EmailDisclaimer: React.SFC = () => (
  <h4 className={classnames(styles.disclaimer)}>We use this email address to send you your matched results</h4>
)
